import { ThemeOptions } from '@material-ui/core/styles';
import { coloresBase } from '@infotrack/presentacion-transversales/constantes';

export const estilosMaterialUI: ThemeOptions = {
    overrides: {
        MuiCardContent: {
            root: {
                padding: 24,
            },
        },
        MuiDialogContent: {
            root: {
                padding: 24,
            },
        },
        MuiOutlinedInput: {
            adornedEnd: {
                paddingRight: 0,
            },
        },
        MuiDialog: {
            paper: {
                overflowX: 'hidden',
                overflowY: 'hidden',
            },
        },
        MuiMenu: {
            paper: {
                maxHeight: 300,
            },
        },
    },
    props: {
        MuiTextField: {
            size: 'small',
        },
        MuiToolbar: {
            variant: 'dense',
        },
    },
    palette: {
        text: {
            secondary: coloresBase.paletaGeneral.gris,
        },
    },
};

export const NOMBRE_APLICACION_POR_DEFECTO = 'Smart Suite';
